// extracted by mini-css-extract-plugin
export default {"Token":"TokenizedQuery-module__Token--tYuXk"};